import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { DialogService } from '@nrwl/common-lib';
import { IValueChangedEvent } from '../../../wizard.content';
import { filter, forEach } from 'lodash';
@Component({
  selector: 'wizard-user-to-group',
  templateUrl: './fusio.sso.user.to.group.html',
  providers: [],
  styleUrls: ['../wizard.user.style.scss']
})
export class FusionSsoUserToGroupComponent implements OnInit {
  // eslint-disable-next-line @angular-eslint/no-output-on-prefix
  @Output() onDataValueChange = new EventEmitter<IValueChangedEvent>();

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Input() step: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Input() subStep: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Input() wizardCtrl: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  wizardService: any;
  dialogService: DialogService;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  selectedAll: any;

  ngOnInit() {
    this.wizardService = this.wizardCtrl.wizardService;
    this.wizardService.editMode = true;
    this.selectedAll = {
      isChecked: false
    };
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types,@typescript-eslint/no-explicit-any
  flipValue(group: any): void {
    if (!group.disabled) {
      this.selectGroup(group);
    }
    this.onDataValueChange.emit({
      componentId: 'add_users_to_groups',
      key: 'groupId',
      newValue: filter(this.step.dataSource, { isChecked: true }),
      isValid: true
    });
  }

  flipValues(): void {
    this.selectedAll.isChecked = !this.selectedAll.isChecked;
    this.selectAllGroup();
    this.onDataValueChange.emit({
      componentId: 'add_users_to_groups',
      key: 'groupId',
      newValue: filter(this.step.dataSource, { isChecked: true }),
      isValid: true
    });
  }
  selectAllGroup(): void {
    forEach(this.step.dataSource, item => {
      item.isChecked = this.selectedAll.isChecked && !item.disabled;
      if (item.name === 'readonly') {
        item.isChecked = false;
      }
    });
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types,@typescript-eslint/no-explicit-any
  selectGroup(group: any): void {
    group.isChecked = !group.isChecked;
    this.setCheckboxValues(group);
    this.selectAllGroupValue();
  }

  selectAllGroupValue(): void {
    const data = filter(this.step.dataSource, { isChecked: true });
    this.selectedAll.isChecked = false;
    if (data.length === this.step.dataSource.length) {
      this.selectedAll.isChecked = true;
    }
  }

  clickDetected(): boolean {
    return false;
  }

  isLoading(): boolean {
    return this.wizardService.isLoading;
  }
  // eslint-disable-next-line
  setCheckboxValues(group) {
    if (group.name === 'readonly') {
      this.step.dataSource.forEach(item => {
        if (item.name !== 'readonly') {
          item.isChecked = false;
        }
      });
    } else {
      this.step.dataSource.forEach(item => {
        if (item.name === 'readonly') {
          item.isChecked = false;
        }
      });
    }
  }
}
